import axios from "axios";

const state = {
    eventos: null,
    totalPaginas: null,
};

const getters = {
    eventos: (state) => state.eventos,
    totalPaginas: (state) => state.totalPaginas,
};

const mutations = {
    setEventos: (state, eventos) => {
        state.eventos = eventos;
    },

    setTotalPaginas: (state, data) => {
        state.totalPaginas = data;
    },
};

const actions = {


    async consultarEventosPagina({commit}, data) {
        try {
            let res = await axios.get(`/v1/eventos-directos/pagina/${data.pagina}`);
            commit("setEventos", res?.data?.result);
        } catch (error) {
            return error;
        }
    },
    async consultarEventosDirectosTotalPagina({commit}) {
        try {
            let res = await axios.get(`/v1/eventos-directos/total`);
            commit("setTotalPaginas", res?.data);
        } catch (error) {
            return error;
        }
    },
    async cargarArchivo({commit}, data) {
        try {
            const headers = {'Content-Type': 'multipart/form-data'};
            let resp = await axios.post(`/v1/eventos-directos/upload`, data, {headers});
            commit("setMensaje", "Se ha cargado con éxito el archivo");
            return {
                success: true,
                data: resp.data,
            }
        } catch (error) {
            return {
                success: false,
                data: error.response.data.errors
            }
        }
    },

}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
